import { createApi } from '@reduxjs/toolkit/query/react';

import { API_TAG_TYPES } from 'constants/apiTagTypes';
import { baseQuery } from 'store/baseQuery';

export const baseApi = createApi({
  baseQuery,
  reducerPath: 'api',
  tagTypes: Object.values(API_TAG_TYPES),
  endpoints: () => ({}),
});
